import React from 'react';
import Skeleton from 'react-skeleton-loader';

const skeletonInlineLoader = (width = 150) => (
  <Skeleton width={`${width}px`} count={1} />
);

const skeletonTableNestLoader = (length, width = 150) => {
  const test = [];
  for (let i = 0; i < length; i++) {
    test.push(<td key={i}>{skeletonInlineLoader(width)}</td>);
  }
  const key =
    Math.floor(Math.random() * 1000).toString() +
    Math.floor(Math.random() * 1000);
  return <tr key={key}>{test}</tr>;
};

const skeletonTableLoader = (length, depth, skeletonWidth) => {
  if (length === 1 && depth === 1) {
    return skeletonInlineLoader(skeletonWidth);
  }

  const test = [];
  for (let i = 0; i < length; i++) {
    test.push(skeletonTableNestLoader(depth, skeletonWidth));
  }

  return <>{test}</>;
};

export default skeletonTableLoader;
